import { Card, Empty, List, Typography } from "antd"
import React from "react"
import { Link } from "react-router-dom"

interface ActivityFeedEntry {
  id: string
  title: string
  relative: string
  to: string | null
}

interface ActivityFeedSectionProps {
  title: string
  emptyText: string
  items: ActivityFeedEntry[]
}

export const ActivityFeedSection = ({
  title,
  emptyText,
  items
}: ActivityFeedSectionProps) => (
  <section data-testid={"mobile-home-feed"}>
    <Typography.Title level={5} className={"!mb-2"}>
      {title}
    </Typography.Title>

    {items.length === 0 ? (
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={emptyText} />
    ) : (
      <Card size={"small"} styles={{ body: { padding: 0 } }}>
        <List
          size={"small"}
          dataSource={items}
          renderItem={(item) => (
            <List.Item>
              <div className={"flex w-full flex-col"}>
                {item.to ? (
                  <Link to={item.to}>{item.title}</Link>
                ) : (
                  <Typography.Text>{item.title}</Typography.Text>
                )}
                <Typography.Text type={"secondary"} className={"text-xs"}>
                  {item.relative}
                </Typography.Text>
              </div>
            </List.Item>
          )}
        />
      </Card>
    )}
  </section>
)

export type { ActivityFeedEntry }
